// Ikona dopravy zdarma na detailu produktu (mock C schválený Tomášem 2026-09-23,
// ops/sweeps/2026-09-23-ikona-doprava-zdarma/): značka vpravo dole na hlavní
// fotce + řádek „Doprava zdarma na výdejní místo" pod časovou osou nákupního boxu.
//
// Nahrazuje ruční příznak „Doprava zdarma" z adminu (CZ `custom2`, SK
// `doprava-zadarmo`), který s cenou dopravy nijak nesouvisel a slibovalo ho
// i těžké zboží. Rozhoduje PLATFORMA: nabídka dopravy produktu (tentýž cachovaný
// fetch jako řádek dopravy a modal „Možnosti doručení") nese u výdejního místa
// cenu 0, když produkt sám splní řádek ceníku zdarma (`offerHasFreeBox`). Nabídka
// je pro stránku jedna (kód hlavního produktu), varianta s jinou cenou/hmotností
// ji nemění — proto se u variantního produktu nic neslibuje.
// Za přepínačem `freeShipMark` (features.js): ostrá až po odebrání příznaku v den D.
import { icon } from './icon.js';
import { featureOn } from './features.js';
import { loadShippingOptions, offerHasFreeBox, shippingPromo, isPromoRow } from './shippingModel.js';
import { carrierLogo } from './logo.js';
import { money } from './money.js';
import { shoptetData } from '../shoptet-hooks.js';
import L from '../locale/cs/freeShipMark.js';

function buildMark() {
  const mark = document.createElement('span');
  mark.className = 'bs-free-mark';
  mark.setAttribute('aria-hidden', 'true'); // celé sdělení nese řádek v nákupním boxu
  mark.appendChild(icon('truck'));
  const label = document.createElement('span');
  label.textContent = L.mark;
  mark.appendChild(label);
  mark.hidden = true;
  return mark;
}

// Akce na dopravu (#322, mock M2 varianta b): značka ve stejném rohu fotky,
// místo náklaďáku logo dopravce a pod ním akční cena. Doprava zdarma a akce se
// vylučují (nabídka nese u výdejního místa buď 0, nebo akční cenu).
function buildPromoMark(pr) {
  const mark = document.createElement('span');
  mark.className = 'bs-free-mark bs-free-mark--promo';
  mark.setAttribute('aria-hidden', 'true'); // sdělení nese řádek dopravy v nákupním boxu
  const logo = carrierLogo(pr.carrier, 'bs-free-mark__logo');
  if (logo) mark.appendChild(logo);
  const label = document.createElement('span');
  label.textContent = money(pr.price);
  mark.appendChild(label);
  return mark;
}

function buildRow() {
  const row = document.createElement('div');
  row.className = 'bs-buy__free';
  row.appendChild(icon('truck'));
  const txt = document.createElement('span');
  const strong = document.createElement('b');
  strong.textContent = L.rowStrong;
  txt.appendChild(strong);
  txt.appendChild(document.createTextNode(' ' + L.rowRest));
  row.appendChild(txt);
  row.hidden = true;
  return row;
}

/**
 * @param {HTMLElement|null} card nákupní box (`.bs-buy`)
 * @param {HTMLElement|null} image hlavní fotka (`.p-image`)
 */
export function mountFreeShipMark(card, image) {
  if (!featureOn('freeShipMark') || !card) return;
  const product = shoptetData('product');
  if (product && product.hasVariants === true) return;
  const link = card.querySelector('a.shipping-options');
  const ship = card.querySelector('.bs-buy__ship');
  if (!link || !ship || card.querySelector('.bs-buy__free')) return;

  const row = buildRow();
  ship.appendChild(row);
  const mark = image ? buildMark() : null;
  if (mark) image.appendChild(mark);

  // do odpovědi nabídky se nic neslibuje (obě části skryté)
  loadShippingOptions(link.getAttribute('href')).then(function (data) {
    const on = offerHasFreeBox(data && data.rows);
    row.hidden = !on;
    if (mark) mark.hidden = !on;
    if (on || !image) return;
    const pr = shippingPromo();
    const promo =
      pr &&
      data &&
      data.rows.some(function (r) {
        return isPromoRow(r, pr);
      });
    if (promo && !image.querySelector('.bs-free-mark--promo')) image.appendChild(buildPromoMark(pr));
  });
}
